import { IFeatureBase, IFeatureGroupBase } from '../../models/features';
import wbsBookingsApi from '../apis/wbsBookingsApi';

export interface IDetailedFeatureGroup extends IFeatureGroupBase {
  features: IFeatureBase[];
  featuresCount: number;
  usersCount: number;
}

export const showFeatureGroupsService = async (
  featureGroupId: string,
): Promise<IDetailedFeatureGroup> => {
  const { data } = await wbsBookingsApi.get<IDetailedFeatureGroup>(
    `/feature-groups/${featureGroupId}`,
  );

  return data;
};
